import { render } from "./FormErrors.vue?vue&type=template&id=9c8098ce"
import script from "./FormErrors.vue?vue&type=script&lang=js"
export * from "./FormErrors.vue?vue&type=script&lang=js"

import exportComponent from "/builds/apps/elevate/shepherd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__